import { AUTH_ENDPOINTS } from "./auth/index"
import { PLANS_ENDPOINTS } from "./plans"
import { PROMPTS_ENDPOINTS } from "./prompts"
import { USERS_ENDPOINTS } from "./users"

export const API_ENDPOINTS = {
  auth: AUTH_ENDPOINTS,
  users: USERS_ENDPOINTS,
  prompts: PROMPTS_ENDPOINTS,
  plans: PLANS_ENDPOINTS,
}